export default function AuthLayout({ children }) {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      {/* Left side - Auth */}
      {children}

      {/* Right side - Info */}
      <div className="hidden lg:flex items-center dark:bg-sky-600 bg-sky-600 p-12">
        <div className="mx-auto max-w-lg text-center text-white">
          <h1 className="mb-6 text-4xl font-bold tracking-tight">
            Streamline your government contracting process
          </h1>
          <p className="mb-8 text-lg opacity-90">
            Access thousands of government opportunities and manage your bids
            efficiently
          </p>

          {/* Stats Display */}
          <div className="grid grid-cols-2 gap-6">
            <div className="rounded-lg bg-white/10 backdrop-blur-sm p-6">
              <div className="text-3xl font-bold">$180B+</div>
              <div className="text-sm opacity-90">Annual Contract Value</div>
            </div>
            <div className="rounded-lg bg-white/10 backdrop-blur-sm p-6">
              <div className="text-3xl font-bold">100K+</div>
              <div className="text-sm opacity-90">Active Opportunities</div>
            </div>
            <div className="rounded-lg bg-white/10 backdrop-blur-sm p-6">
              <div className="text-3xl font-bold">1000+</div>
              <div className="text-sm opacity-90">Businesses Trust Us</div>
            </div>
            <div className="rounded-lg bg-white/10 backdrop-blur-sm p-6">
              <div className="text-3xl font-bold">24/7</div>
              <div className="text-sm opacity-90">Support Available</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
